<template>
  <div class="theme-heading">
    <div class="theme-heading__avatar">
      <img src="/static/img/avatar/study.png" loading="lazy" alt="зоозавр"/>
    </div>
    <div class="theme-heading__bullet">Тема 3</div>
    <h1 class="theme-heading__title">Питание</h1>
    <p class="theme-heading__text">Что важно знать?</p>
  </div>

  <div class="topic">
    <div class="theme-point"><span class="theme-point__number">1</span>
      <h2 class="theme-point__title">Питание котенка</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-3/cat-1.webp" type="image/webp">
          <img src="/static/img/theme-3/cat-1.png" alt="Питание котенка"/>
        </picture>
      </div>
      <p class="theme-point__text"><span class="accent">Вначале не&nbsp;меняйте питание котенка</span>. Любые резкие изменения в&nbsp;питании могут привести к&nbsp;расстройству пищеварения или стрессу.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">В&nbsp;первую неделю обеспечьте котенку такие&nbsp;же корм и&nbsp;распорядок кормления, как у&nbsp;предыдущего владельца. Затем при желании вы&nbsp;можете постепенно перейти на&nbsp;свой распорядок и&nbsp;корм для котят, подходящий по&nbsp;возрасту.</p>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">2</span>
      <h2 class="theme-point__title">сбалансированный рацион</h2>
      <p class="theme-point__text">Очень важно <span class="accent">выбрать правильный сбалансированный корм для вашей кошки</span>, который будет учитывать ее&nbsp;потребности и&nbsp;особенности здоровья.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Выбор корма для кошки зависит от&nbsp;многих факторов: от&nbsp;ее&nbsp;возраста, активности, длины шерсти и&nbsp;состояния здоровья. В&nbsp;случае возникновения вопросов о&nbsp;смене питания, не&nbsp;стесняйся задавать их&nbsp;ветеринарному врачу</p>
      </div>
      <div class="theme-point__slider-block hide-desktop">
        <h3 class="theme-point__slider-title">Для котят</h3>
        <div class="swiper theme-point__slider" data-theme-point-slider>
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/cat-slider-1-1.webp" type="image/webp">
                <img src="/static/img/theme-3/cat-slider-1-1.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/cat-slider-1-2.webp" type="image/webp">
                <img src="/static/img/theme-3/cat-slider-1-2.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/cat-slider-1-3.webp" type="image/webp">
                <img src="/static/img/theme-3/cat-slider-1-3.png" alt="">
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <div class="theme-point__slider-block hide-desktop">
        <h3 class="theme-point__slider-title">Для взрослых кошек</h3>
        <div class="swiper theme-point__slider" data-theme-point-slider>
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/cat-slider-2-1.webp" type="image/webp">
                <img src="/static/img/theme-3/cat-slider-2-1.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/cat-slider-2-2.webp" type="image/webp">
                <img src="/static/img/theme-3/cat-slider-2-2.png" alt="">
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/cat-slider-2-3.webp" type="image/webp">
                <img src="/static/img/theme-3/cat-slider-2-3.png" alt="">
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <div class="theme-point-tabs">
        <button
          class="theme-point-tabs__btn"
          data-tab-button="kitten"
          data-tab-button-state="active"
          @click="sendEventYM('diet_step3_click_btn', {'diet_step3_click_btn_param': 'Для котят'})"
        >Для котят</button>
        <button
          class="theme-point-tabs__btn"
          data-tab-button="cat"
          @click="sendEventYM('diet_step3_click_btn', {'diet_step3_click_btn_param': 'Для взрослых кошек'})"
        >Для взрослых кошек</button>
      </div>
      <div class="theme-point-panels">
        <div class="theme-point-panels__panel" data-tab-panel="kitten" data-tab-panel-state="active">
          <div class="swiper theme-point__slider" data-theme-point-slider>
            <div class="swiper-wrapper">
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/cat-slider-1-1.webp" type="image/webp">
                  <img src="/static/img/theme-3/cat-slider-1-1.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/cat-slider-1-2.webp" type="image/webp">
                  <img src="/static/img/theme-3/cat-slider-1-2.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/cat-slider-1-3.webp" type="image/webp">
                  <img src="/static/img/theme-3/cat-slider-1-3.png" alt="">
                </picture>
              </div>
            </div>
            <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
          </div>
          <span class="theme-point__slider-text">Листайте карусель</span>
        </div>
        <div class="theme-point-panels__panel" data-tab-panel="cat">
          <div class="swiper theme-point__slider" data-theme-point-slider>
            <div class="swiper-wrapper">
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/cat-slider-2-1.webp" type="image/webp">
                  <img src="/static/img/theme-3/cat-slider-2-1.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/cat-slider-2-2.webp" type="image/webp">
                  <img src="/static/img/theme-3/cat-slider-2-2.png" alt="">
                </picture>
              </div>
              <div class="swiper-slide theme-point__slide">
                <picture>
                  <source srcset="/static/img/theme-3/cat-slider-2-3.webp" type="image/webp">
                  <img src="/static/img/theme-3/cat-slider-2-3.png" alt="">
                </picture>
              </div>
            </div>
            <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination></div>
          </div>
          <span class="theme-point__slider-text">Листайте карусель</span>
        </div>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">3</span>
      <h2 class="theme-point__title">Смена рациона котенка или взрослой кошки</h2>
      <div class="theme-point__slider-block">
        <div class="swiper theme-point__slider" data-theme-point-slider="data-theme-point-slider">
          <div class="swiper-wrapper">
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/cat-slider-3-1.webp" type="image/webp">
                <img src="/static/img/theme-3/cat-slider-3-1.jpg" alt=""/>
              </picture>
            </div>
            <div class="swiper-slide theme-point__slide">
              <picture>
                <source srcset="/static/img/theme-3/cat-slider-3-2.webp" type="image/webp">
                <img src="/static/img/theme-3/cat-slider-3-2.jpg" alt=""/>
              </picture>
            </div>
          </div>
          <div class="theme-point__pagination swiper-pagination" data-theme-point-slider-pagination="data-theme-point-slider-pagination"></div>
        </div>
        <span class="theme-point__slider-text">Листайте карусель</span>
      </div>
      <p class="theme-point__text">В&nbsp;некоторых случаях вы&nbsp;можете решить, что пришло время поменять рацион кошки.</p>
      <div class="theme-point__numbered">
        <div class="theme-point__numbered-title">3&nbsp;причины поменять рацион</div>
        <ul class="theme-point__numbered-list">
          <li class="theme-point__numbered-item"><span class="number">1</span>
            <div>
              <p class="text">Котенок готов перейти на&nbsp;взрослый корм</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">2</span>
            <div>
              <p class="text">Состояние здоровья кошки изменилось, и&nbsp;ей&nbsp;требуется специальная диета</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">3</span>
            <div>
              <p class="text">Вы&nbsp;хотите перевести кошку на&nbsp;влажный, сухой корм или смешанное кормление</p>
            </div>
          </li>
        </ul>
      </div>
      <p class="theme-point__text">Рекомендуется <span class="accent">постепенный перевод</span> кошки на&nbsp;новый рацион <span class="accent">как минимум в&nbsp;течение недели</span>. Это позволит избежать расстройства желудка, неофобии и&nbsp;прочих стрессов.</p>
      <div class="theme-point__ordered desktop-grow">
        <ol class="theme-point__ordered-list">
          <li class="theme-point__ordered-item"><span class="paw">
                      <svg class="icon-paw">
                        <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
                      </svg></span>
            <div>
              <p class="text"><span class="accent">Дни 1&nbsp;и&nbsp;2&nbsp;</span> — 75&nbsp;% прежнего корма + 25&nbsp;% нового корма</p>
            </div>
          </li>
          <li class="theme-point__ordered-item"><span class="paw">
                      <svg class="icon-paw">
                        <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
                      </svg></span>
            <div>
              <p class="text"><span class="accent">Дни 3&nbsp;и&nbsp;4&nbsp;</span> — 50&nbsp;% прежнего корма + 50&nbsp;% нового корма</p>
            </div>
          </li>
          <li class="theme-point__ordered-item"><span class="paw">
                      <svg class="icon-paw">
                        <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
                      </svg></span>
            <div>
              <p class="text"><span class="accent">Дни 5&nbsp;и&nbsp;6&nbsp;</span> — 25&nbsp;% прежнего корма + 75&nbsp;% нового корма</p>
            </div>
          </li>
          <li class="theme-point__ordered-item"><span class="paw">
                      <svg class="icon-paw">
                        <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
                      </svg></span>
            <div>
              <p class="text"><span class="accent">День 7</span> — 100&nbsp;% нового корма</p>
            </div>
          </li>
        </ol>
      </div>
    </div>
    <div class="theme-point"><span class="theme-point__number">4</span>
      <h2 class="theme-point__title">РЕКОМЕНДАЦИИ ПО&nbsp;КОРМЛЕНИЮ</h2>
      <div class="theme-point__img">
        <picture>
          <source srcset="/static/img/theme-3/cat-4.webp" type="image/webp">
          <img src="/static/img/theme-3/cat-4.png" alt="РЕКОМЕНДАЦИИ ПО&amp;nbsp;КОРМЛЕНИЮ"/>
        </picture>
      </div>
      <p class="theme-point__text">Кошки, следуя инстинкту, <span class="accent">едят от&nbsp;10&nbsp;до&nbsp;20&nbsp;раз в&nbsp;день</span>. Так питались в&nbsp;дикой природе их&nbsp;предки, которые в&nbsp;одиночку охотились на&nbsp;мелкую добычу.</p>
      <div class="theme-point__block">
        <div class="theme-point__block-icon">
          <svg class="icon-paw">
            <use xlink:href="/static/img/sprites/sprite.svg#paw"></use>
          </svg>
        </div>
        <p class="theme-point__block-text">Поскольку в&nbsp;наши дни кошки ведут гораздо менее активный образ жизни, важно следить за&nbsp;их&nbsp;весом: соблюдать нормы кормления и&nbsp;обеспечивать животным возможности для движения. Для этого можно использовать, в&nbsp;частности, &laquo;пищевые головоломки&raquo;&nbsp;&mdash; игрушки, из&nbsp;которых кошка может достать корм, только приложив усилия.<br><br>Кошки предпочитают есть в&nbsp;спокойном месте, не&nbsp;на&nbsp;проходе. Это тоже генетическая память о&nbsp;прошлом, когда им&nbsp;приходилось остерегаться хищников.</p>
      </div>
      <div class="theme-point__numbered desktop-grow">
        <div class="theme-point__numbered-title">Полезные советы</div>
        <ul class="theme-point__numbered-list">
          <li class="theme-point__numbered-item"><span class="number">1</span>
            <div>
              <h3 class="title">КОШКИ ЕДЯТ НЕБОЛЬШИМИ ПОРЦИЯМИ В&nbsp;ТЕЧЕНИЕ ВСЕГО ДНЯ</h3>
              <p class="text">Но&nbsp;не&nbsp;забывайте соблюдать суточные нормы кормления, чтобы уберечь кошку от&nbsp;избыточного веса.</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">2</span>
            <div>
              <h3 class="title">КОТЯТА СПОСОБНЫ ПЕРЕВАРИВАТЬ МОЛОКО</h3>
              <p class="text">Но&nbsp;у&nbsp;взрослых кошек развивается непереносимость лактозы.</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">3</span>
            <div>
              <h3 class="title">НЕ&nbsp;КОРМИТЕ КОШКУ СВОЕЙ ЕДОЙ</h3>
              <p class="text">Еда с&nbsp;нашего стола не&nbsp;подходит для кошки.</p>
            </div>
          </li>
          <li class="theme-point__numbered-item"><span class="number">4</span>
            <div>
              <h3 class="title">ПОТРЕБНОСТИ КОШЕК В&nbsp;ПИТАТЕЛЬНЫХ ВЕЩЕСТВАХ МОГУТ МЕНЯТЬСЯ</h3>
              <p class="text">В&nbsp;зависимости от&nbsp;возраста, состояния здоровья, образа жизни и&nbsp;даже породы.</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="topic__img">
    <img src="/static/img/zoozavr.png" loading="lazy" alt="зоозавр"/>
  </div>

  <button class="btn topic__btn"
  @click="$emit('goToQuiz'); sendEventYM('quiz3_click_btn')"
  >Закрепить знания</button>
</template>

<script>
import { onMounted, onBeforeUnmount } from 'vue'
import { SliderManager } from '@/assets/js/script.js'
import analyticsTracking from '@/mixins/analyticsTracking.js'
import 'swiper/css'
import 'swiper/css/pagination'

export default {
  name: 'LessonCatsTopic3',
  mixins: [analyticsTracking],
  emits: ['goToQuiz'],
  setup() {
    let sliderManager = null

    onMounted(() => {
      sliderManager = new SliderManager()
      sliderManager.init()
    })

    onBeforeUnmount(() => {
      if (sliderManager) {
        sliderManager.destroy()
        sliderManager = null
      }
    })

    return {}
  }
}
</script>

<style scoped>
</style>
